module.exports = __webpack_public_path__ + "1ace669f0c88531f715b9b275ae7414c.woff2";